import { Typography } from '@material-ui/core'
import ContentToolbarPage from 'app/components/ContentToolbarPage'
import LargeToolbar from 'app/components/LargeToolbar'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as R from 'ramda'
import NetworkError from 'app/components/NetworkError'
import { useIsOnline } from 'commons/useIsOnline'

import PlanBillingContent from './PlanBillingContent'

function PlanBilling({ location }) {
  const [isOnline] = useIsOnline()
  const isOpenChangePlanDialog = R.pathOr(
    false,
    ['state', 'isShowUpgradePlan'],
    location,
  )

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => {}} />
  }
  return (
    <ContentToolbarPage
      contentToolbar={
        <LargeToolbar
          content={
            <>
              <Typography variant="h6">
                <FormattedMessage id="navigation.planAndBilling.billingOverview.label" />
              </Typography>
            </>
          }
        />
      }
      content={
        <PlanBillingContent isOpenChangePlanDialog={isOpenChangePlanDialog} />
      }
    />
  )
}

export default PlanBilling
